module.exports = __webpack_public_path__ + "img/edit.e2501c6d.svg";